import { setSession, getSession } from '@utils/storage.js';

import { parseQuery } from '@tencent/slug-function';

const TOKEN = 'tokenParams';
let search = '';
let obj = {};
const tokenSource = [
  window.location.search,
  window.location.hash,
  getSession(TOKEN),
];
for (let i = 0; i < tokenSource.length; i++) {
  // 转换为String规避Number类型引用indexOf方法报错的问题
  if (tokenSource[i].toString().indexOf('msdkEncodeParam=') > -1  || tokenSource[i].toString().indexOf('itopencodeparam=') > -1) {
    search = tokenSource[i];
    break;
  }
}
if (search) {
  search = search.slice(search.indexOf('?'));
  obj = parseQuery(search);
  setSession(TOKEN, search);
} else {
}
export const tokenObj = Object.assign(
  {
    agent: /iPad|iPhone|iPod/.test(window.navigator.userAgent)
      ? 'ios'
      : 'android',
    openid: '',
    roleid: '',
    platid: '',
    areaid: '',
  },
  obj,
);

export const tokenParamsStr = search;
